import { useEffect, useState } from "react";
//HOOK FROM https://dev.to/payalsasmal/custom-hook-to-get-windows-width-and-height-in-react-dynamically-4b4l
const useSize = () => {
  const [windowSize, setWindowSize] = useState([
    window.innerHeight,
    window.innerWidth,
  ]);

  useEffect(() => {
    const windowSizeHandler = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", windowSizeHandler);

    return () => {
      window.removeEventListener("resize", windowSizeHandler);
    };
  }, []);

  return {windowSize};
};

export default useSize;